import Box from '@material-ui/core/Box';
import { FormattedMessage } from 'react-intl';
import { useQuotationContext } from '../contexts/QuotationContext';
import { ALERT_RED } from '../helpers/colors';

const ErrorMessagePanel = () => {
  const { values, validateIssueAge, activeProduct } = useQuotationContext();

  const isIssueAgeValid = validateIssueAge(activeProduct, values.age);

  return !isIssueAgeValid ? (
    <Box px={2} pb={1} color={ALERT_RED} m={8}>
      <FormattedMessage id="invalid-age" values={values} />
    </Box>
  ) : null;
};

export default ErrorMessagePanel;
